import React from 'react'
import ManageBooksDetail from '../manage-books/ManageBooksDetail';
import { ELibraryCategory } from '../../enum/elibrary_enum';
import { routeName } from '../../../../routes/routeName';
import { useTranslation } from 'react-i18next';

type Props = {
    view: boolean;
}

const ManageAudioBookDetail = ({ view }: Props) => {
    const { t } = useTranslation();
    return (
        <ManageBooksDetail
            library_category_name={ELibraryCategory.AUDIO_BOOK}
            view={view}
            menu_name={t('จัดการหนังสือเสียง')}
            menu_name_detail={t("เพิ่มหนังสือเสียง")}
            menu_name_detail_edit={t("รายละเอียดหนังสือเสียง")}
            menu_path_name={routeName.e_library.manage_audio_book}
        />
    )
}

export default ManageAudioBookDetail